import { t } from "@lingui/macro";
import { PayloadAction } from "@reduxjs/toolkit";
import { message } from "antd";
import { call, put, takeLatest } from "redux-saga/effects";
import api from "service/apiService";
import { setLoadingPage } from "store/app/app.slice";
import { ApiResponse } from "types";
import { translate } from "utils";
import { ServiceCategoryDetail } from "../types";
import {
	createServiceCategoryAsync,
	CreateServiceCategoryAsyncPayload,
	getDetailServiceCategoryAsync,
	GetDetailServiceCategoryAsyncPayload,
	getListServiceCategoryAsync,
	GetListServiceCategoryPayload,
	setDetailServiceCategory,
	setListServiceCategory,
	setTotalServiceCategory,
	updateServiceCategoryAsync,
	UploadServiceCategoryAsyncPayload,
} from "./serviceCategory.slice";

function* getListServiceCategorySaga(
	action: PayloadAction<GetListServiceCategoryPayload>,
) {
	const { query, callback } = action.payload;
	const { response, error } = yield call(async () => {
		try {
			const { data: response } = await api.get<
				ApiResponse<ServiceCategoryDetail[]>
			>("dashboard/service-categories", {
				...query,
				skip: query.skip * query.take,
			});
			return { response };
		} catch (error) {
			return { error };
		}
	});
	if (response) {
		yield put({ type: setListServiceCategory.type, payload: response });
		yield put({ type: setTotalServiceCategory.type, payload: response });
		callback && callback();
	} else {
		message.error(translate(error.message));
	}
}
function* watchGetListServiceCategory() {
	yield takeLatest(getListServiceCategoryAsync, getListServiceCategorySaga);
}

function* getDetailServiceCategorySaga(
	action: PayloadAction<GetDetailServiceCategoryAsyncPayload>,
) {
	const { id, callback } = action.payload;
	const { response, error } = yield call(async () => {
		try {
			const { data: response } = await api.get<
				ApiResponse<ServiceCategoryDetail>
			>(`dashboard/service-categories/${id}`);
			return { response };
		} catch (error) {
			return { error };
		}
	});
	if (response) {
		callback && callback();
		yield put({ type: setDetailServiceCategory.type, payload: response });
	} else {
		message.error(translate(error.message));
	}
}

function* watchGetDetailServiceCategory() {
	yield takeLatest(getDetailServiceCategoryAsync, getDetailServiceCategorySaga);
}

function* createServiceCategorySaga(
	action: PayloadAction<CreateServiceCategoryAsyncPayload>,
) {
	// yield put({ type: setLoadingPage.type, payload: true });
	const { data, callback } = action.payload;
	const { response, error } = yield call(async () => {
		try {
			const { data: response } = await api.post("dashboard/service-categories", data);
			return { response };
		} catch (error) {
			return { error };
		}
	});
	if (response) {
		message.success(translate("Create success"));
		callback();
	} else {
		message.error(translate(error.message));
	}
	// yield put({ type: setLoadingPage.type, payload: false });
}

function* watchCreateServiceCategory() {
	yield takeLatest(createServiceCategoryAsync, createServiceCategorySaga);
}

function* updateServiceCategorySaga(
	action: PayloadAction<UploadServiceCategoryAsyncPayload>,
) {
	const { id, data, callback } = action.payload;
	// yield put({ type: setLoadingPage.type, payload: true });
	const { response, error } = yield call(async () => {
		try {
			const { data: response } = await api.patch(
				`dashboard/service-categories/${id}`,
				data,
			);
			return { response };
		} catch (error) {
			return { error };
		}
	});
	if (response) {
		callback && callback();
		message.success(t`Update successful`);
	} else {
		message.error(translate(error.message));
	}
	// yield put({ type: setLoadingPage.type, payload: false });
}

function* watchUpdateServiceCategory() {
	yield takeLatest(updateServiceCategoryAsync, updateServiceCategorySaga);
}

const customerSaga = [
	watchGetListServiceCategory(),
	watchGetDetailServiceCategory(),
	watchCreateServiceCategory(),
	watchUpdateServiceCategory(),
];

export default customerSaga;
